import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setBloodProductOptions } from '../store/options.actions'

export function* getBloodProductOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getBloodProductOptions])
    const { entity } = response
    yield put(setBloodProductOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getBloodProductOptions() error: ${e}`))
  }
}
export function* getBloodProductOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getBloodProductOptions)
}
